import { IconV1 } from 'common/icon/iconV1.js';
import { MSImage } from 'common/image/ms-image.js';
import { ComponentLink } from 'common/link/link-component.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { ReferenceProps } from 'common/reference/reference.js';
import { Tile } from 'common/tile/tile.js';
import {
  getBBQIconName,
  getBBQRatingClass,
  getBBQRatingName,
  getBBQRatingTextClass,
} from 'components/map/marker-view/collections/bbq/bbq-utils.js';
import { IModule } from 'redux-state/layout/types.js';
import { LinkTarget } from 'types/navigation.js';

export type AdvertBBQForecastProps = {
  rating: number;
  sponsor?: ReferenceProps;
  buttonText?: string;
  buttonUrl?: string;
};

export const AdvertBBQForecast = ({ config }: IModule<AdvertBBQForecastProps>) => {
  const { rating, sponsor, title, buttonText, buttonUrl } = config;
  const ratingText = getBBQRatingName(rating);
  const ratingTextClass = getBBQRatingTextClass(rating);
  const ratingIconClass = getBBQRatingClass(rating);
  const iconBBQName = getBBQIconName(rating);

  return (
    <Tile dataModule="advert-BBQ" config={config}>
      <div
        className="Tile-body"
        style={{
          paddingRight: '18px',
          paddingLeft: '18px',
          paddingTop: '12px',
          paddingBottom: '12px',
        }}
      >
        <div className="u-flex">
          <div className="u-flex-1">
            {sponsor?.image && (
              <div className="u-flexGrow-0 u-mT-xs u-mB-xs u-flex u-flexJustifyCenter">
                <ComponentLink url={sponsor?.url} target={LinkTarget.BLANK}>
                  <MSImage src={sponsor?.image} />
                </ComponentLink>
              </div>
            )}
            <div className="u-flex u-flexJustifyCenter">
              <div className="u-flex-1" style={{ maxHeight: '3rem' }}>
                <IconV1 icon={iconBBQName} iconClass={`${ratingIconClass} Pill--currentColor`} />
              </div>
            </div>
            <div className={`${ratingTextClass} u-mB-0 u-text-sm u-textBold u-textCenter`}>{ratingText}</div>
          </div>
          <div
            className="u-flex-1 u-mT-xs u-flex u-flexCol"
            style={{
              minWidth: '150px',
            }}
          >
            <h2 className="u-textCenter u-mT-xs u-mB-sm">{title}</h2>

            {buttonUrl && (
              <div className="u-flexGrow-0 u-mT-xs u-mB-xs u-flex u-flexJustifyCenter">
                <LinkFactoryReactRouter
                  data-comp="common-btn"
                  href={buttonUrl}
                  className="u-flex Button Button--secondary Button--slim svg--fill-inherit"
                  aria-label="chevron-right"
                  target={LinkTarget.SELF}
                  role="button"
                >
                  <span>{buttonText}</span>
                  <div className="u-pL-xs u-flex">
                    <IconV1 icon="chevron-right" iconClass="svg--1em" />
                  </div>
                </LinkFactoryReactRouter>
              </div>
            )}
          </div>
        </div>
      </div>
    </Tile>
  );
};
